/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/10/22, 7:34 AM
 *
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Member } from 'types/MemberTypes';
import { RoleAccess } from 'types/RoleTypes';

interface MemberState {
  member: Member;
  role: RoleAccess;
  user: Member;
  userRole: RoleAccess;
  startDate: number;
  endDate: number;
}

const initialState: Partial<MemberState> = {
  startDate: 0,
  endDate: 0,
};

export const memberSlice = createSlice({
  name: 'member',
  initialState,
  reducers: {
    setMember: (state, action: PayloadAction<Member>) => {
      state.member = action.payload;
    },
    setRole: (state, action: PayloadAction<RoleAccess>) => {
      state.role = action.payload;
    },
    setUser: (state, action: PayloadAction<Member>) => {
      state.user = action.payload;
    },
    setUserRole: (state, action: PayloadAction<RoleAccess>) => {
      state.userRole = action.payload;
    },
    setStartDate: (state, action: PayloadAction<number>) => {
      state.startDate = action.payload;
    },
    setEndDate: (state, action: PayloadAction<number>) => {
      state.endDate = action.payload;
    },
    remove: (state) => {
      state.role = undefined;
    },
  },
});

export default memberSlice.reducer;
